import type {
  AssignedWorkflow,
  WorkflowAction,
} from '../../../shared/hooks/useIncidentWorkflow'
import {
  formatActionTimestamp,
  useWorkflowActionUserNames,
} from '../../../shared/hooks/useWorkflowActionUserNames'
import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'

import { SteppedList, SteppedListSection, SuccessBanner } from '@hivewatch/dark'

interface WorkflowCompleteStateIProps {
  assignedWorkflow: AssignedWorkflow | null
  workflowActions: WorkflowAction[]
}

export const WorkflowCompleteState = ({
  assignedWorkflow,
  workflowActions,
}: WorkflowCompleteStateIProps) => {
  const mode = useLightMode()
  const { t } = useTranslation()
  const stepMap = new Map(
    assignedWorkflow?.steps.map((s) => [s.id, s.prompt]) ?? []
  )
  const userNameMap = useWorkflowActionUserNames(workflowActions)

  return (
    <SteppedList colorScheme={mode}>
      {workflowActions.map((action) => (
        <SteppedListSection
          colorScheme={mode}
          content={action.outcomeValue}
          header={stepMap.get(action.sourceNodeId) ?? action.sourceNodeId}
          key={action.id}
          metadata={{
            completedAt: formatActionTimestamp(action.actionTimestamp),
            name: userNameMap.get(action.userId) ?? '',
          }}
        />
      ))}
      <SuccessBanner
        colorScheme={mode}
        label={t('incidents:drawer_workflow_complete_label')}
        mb='12px'
      />
    </SteppedList>
  )
}
